import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { paragraph } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  display: inline-flex;
  place-items: center;
  place-content: center;
  gap: 24px;
  padding: 0 32px;
  height: 50px;
  border: 2px solid ${brand.grey.grey90};
  background-color: ${brand.white};
  border-radius: 100px;

  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
    width: 12px;
    pointer-events: none;
  }
`;
const Label = styled.label `
  ${paragraph}
  ${fonts.montserrat.medium}
  flex-shrink: 0;
  margin: 0;
`;
const Select = styled.select `
  ${paragraph}
  ${fonts.montserrat.regular}
  height: 100%;
  margin: 0;
  border: none;
  outline: none;
  appearance: none;

  &.focus-ring,
  &:focus {
    outline: auto;
    outline-offset: 3px;
    outline-color: var(--textColor);
  }
`;
export const DropdownStyles = {
    Container,
    Label,
    Select,
};
